export default __webpack_public_path__ + "static/media/VN.4c07da29.svg";